import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-close\"><g clip-path=\"url(#icon-close_a)\"><path fill=\"#000\" fill-opacity=\".45\" d=\"M3.812 3.813a8.75 8.75 0 1 1 12.374 12.374A8.75 8.75 0 0 1 3.812 3.813\" /><path fill=\"#fff\" d=\"m12.65 6.464.883.884-6.187 6.188-.884-.884z\" /><path fill=\"#fff\" d=\"m13.533 12.652-.883.884-6.188-6.188.884-.884z\" /></g><defs><clipPath id=\"icon-close_a\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol